import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SessionsList from './list/list';
import SessionsGenerator from './detail/sessionsGenerator';
import SessionDetail from './detail/sessionDetail';
import PageError from '../error/pageError';

export default function SessionRouter({ organization, event, path }) {
    let uuidRegex = '[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}';

    return (
        <Switch>
            <Route exact path={`${path}`} render={() => <SessionsList organization={organization} event={event} />} />
            <Route
                exact
                path={`${path}/:sessionUuid(${uuidRegex})`}
                render={basenameProps => {
                    const sessionUuid = basenameProps.match.params.sessionUuid;
                    return <SessionDetail organization={organization} event={event} sessionUuid={sessionUuid} />;
                }}
            />
            <Route
                exact
                path={`${path}/new`}
                render={basenameProps => {
                    return <SessionsGenerator organization={organization} event={event} />;
                }}
            />
            <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}/E${event.id}/dashboard`} />} />
        </Switch>
    );
}

SessionRouter.propTypes = {
    organization: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
